import { Component, OnInit } from '@angular/core';

import { Frota } from "../shared/frota.model";
import { FrotaApiService } from "../shared/frota-api.service";
import { FrotaNavigationService } from "../shared/frota-navigation.service";
import { FrotasService } from "../shared/frota.service";
import { UtilService } from "../../../shared/services/util.service";
import {
    aeronavesRoute, embarcacoesRoute, equipamentosRoute, maquinarioRoute,
    outrosRoute, veiculosRoute
} from "../shared/data.service";
import { months } from "../../../abastecimentos/abastecimento-bens/shared/data.service";
import {FormaControleService} from "../../formas-controle/shared/forma-controle.service";

@Component({
    template: require('./frota-list.component.html'),
    styles: [require('./frota-list.component.css')]
})
export class FrotaListComponent implements OnInit {
    list: Frota[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    frotasModuleName: any = {};
    thisRoute: string = '';
    odometro: number;
    horimetro: number;

    aeronavesRoute: string = aeronavesRoute;
    embarcacoesRoute: string = embarcacoesRoute;
    equipamentosRoute: string = equipamentosRoute;
    maquinarioRoute: string = maquinarioRoute;
    outrosRoute: string = outrosRoute;
    veiculosRoute: string = veiculosRoute;

    private moduleId: number;
    private monthsList: any[] = months;

    constructor(
        private _frotasApiService: FrotaApiService,
        private _frotasService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _utilService: UtilService,
        private _formaControleService: FormaControleService
    ) { }

    ngOnInit() {
        this.frotasModuleName = this._frotasService.getModuleName();
        this.thisRoute = this._frotasService.getRouteName();
        this.moduleId = this._frotasService.getModuleId();

        this.horimetro = this._formaControleService.getFormaControleHorimetro();
        this.odometro = this._formaControleService.getFormaControleOdometro();

        this.getAll();
    }

    clickNew() {
        this._frotasService.clearSessionStorage();
        this._frotaNavigationService.goToNew(this.thisRoute);
    }

    clickEdit(item: Frota) {
        this._frotasService.clearSessionStorage();
        this._frotaNavigationService.goToEdit(item.id, this.thisRoute);
    }

    clickDelete(item: Frota) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    clickDetail(item: any) {
        this._frotasService.setSessionStorage(item);
        this._frotaNavigationService.goToDetail(item.id, this.thisRoute);
    }

    keyupItem(event: any, item: any) {
        if (event.keyCode === 13) {
            this.clickDetail(item);
        }
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any, y: any, lenY: any;

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    for (y = 0, lenY = this.monthsList.length; y < lenY; y++) {
                        if (Response[x].mesIPVA === this.monthsList[y].Key) {
                            Response[x].mesIPVA = this.monthsList[y];
                        }

                        if (Response[x].mesLicenciamento === this.monthsList[y].Key) {
                            Response[x].mesLicenciamento = this.monthsList[y];
                        }

                        if (Response[x].mesSeguroObrigatorio === this.monthsList[y].Key) {
                            Response[x].mesSeguroObrigatorio = this.monthsList[y];
                        }
                    }
                }

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._frotasApiService.onGetByCategoria(this.moduleId, onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._frotasApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frota-list/frota-list.component.ts
 **/